module.exports = __webpack_public_path__ + "e539f7d32407291bc2acc7d61e7e56fd.svg";